import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Link, useSearchParams } from 'react-router-dom';
import { MdFastfood } from "react-icons/md";
import SafeImage from '../../components/SafeImage';
import imgPizza from '../../img/Pizza2.png';
import { formatPriceWithSymbol } from '../../utils/currency';

function Categoria({ categoria, itens, nomeEmpresaForUrl, idEmpresa, handleSelectCategoria, statusLoja }) {

  const [searchParams] = useSearchParams();

  // Obtém o external_id da URL atual, se existir
  const externalId = searchParams.get('external_id');

  const { ref } = useInView({
    threshold: 1, // Ajuste este valor conforme necessário para melhorar a precisão
    rootMargin: "-140px 0px", // Adiciona uma margem extra para detecção
    onChange: (isVisible) => {
      //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`Categoria ${categoria._id} visível: ${isVisible} ref: ${ref}`);
      if (isVisible) handleSelectCategoria(categoria._id);
    },
  });
  //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(inView)

  return (
    <div id={categoria._id} className="mapContainerCategorias">
      <div className="title-container-mobile">
        <h2>{categoria.title}</h2>
      </div>
      <div className="itens-mobile">
        {categoria._id==="67aab26733a1717e9c57dbb3" && process.env.REACT_APP_ISDEVELOP === 'true' && console.log("itens>>", itens)}
        {itens
          .filter((item) => item.category_item_id === categoria._id)
          .filter((item) => !item.out_salao)
          .map((item, index) => (
            <div key={item._id} className="itens-container-mobile">
              {/*<Link
                className="item-card"
                to={`/cardapio-salao/${nomeEmpresaForUrl}/${idEmpresa}/detalhes-salao/${item._id}`}
                state={{ item, statusLoja }}
              >*/}
              <Link
                className="item-card"
                // Adiciona o external_id na URL se ele existir
                to={
                  externalId
                    ? `/cardapio-salao/${nomeEmpresaForUrl}/${idEmpresa}/detalhes-salao/${item._id}?external_id=${externalId}`
                    : `/cardapio-salao/${nomeEmpresaForUrl}/${idEmpresa}/detalhes-salao/${item._id}`
                }
                state={{ item, statusLoja }}
              >
                <div ref={index === 0 || index === 1 ? ref : null} className="text-info-mobile">
                  <h4>{item.title}</h4>
                  <p className="description-mobile">{item.description}</p>
                  <div className="price-mobile">
                    <p style={{ fontSize: 14 }}>{formatPriceWithSymbol(item.price_salao || 0)}</p>
                  </div>
                </div>
                <div className="image-container-mobile">
                  <div className="picture-mobile">
                    <SafeImage
                      src={item.image}
                      alt={item.title}
                      width={90}
                      height={90}
                      loading="lazy"
                      fallback={
                        item?.type === "pizza"
                          ? <img className="h-56 w-full object-cover" width={90} height={90} src={imgPizza} alt="product" />
                          : <div><MdFastfood style={{ fontSize: 90 }} /></div>
                      }
                    />
                  </div>
                </div>
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Categoria;